const doc = [({"ko":({"adminLabelHotelCalendar":({"endDate":"종료일", "hotelSpecifiedStaysOnlyPeriods":"박 수 한정 기간", "period":"기간", "startDate":"시작일", "stays":"박"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;